import {
    ComparatorPicker,
    ComparatorPickerBuilder,
    ComparatorPickerType,
    ComparisonOperator,
    Field,
    FieldType,
} from "../../vforms-model";
import { TextBoxComponent } from "./text-box.component";
import { TextBoxEditorComponent } from "./text-box-editor.component";
import { assign } from "lodash-es";
import { ComparisonExpression } from "../../expression-settings/model";

export class TextBoxType extends FieldType {
    static Id = "textbox";

    maxLength: number | undefined;

    minLength: number | undefined;

    constructor() {
        super();
        this.id = TextBoxType.Id;
        this.icon = "mat_outline:short_text";
        this.previewComponent = TextBoxComponent;
        this.editorComponent = TextBoxEditorComponent;
    }

    createField(): Field {
        return new TextBox(this);
    }

    supportedComparisonOperators(): ComparisonOperator[] {
        return [
            ...super.supportedComparisonOperators(),
            ComparisonOperator.Equal,
            ComparisonOperator.NotEqual,
            ComparisonOperator.Contains,
            ComparisonOperator.NotContains,
        ];
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        let lowerCaseValue = value?.toLowerCase();
        let lowerCaseExpressionValue = expression.value?.toLowerCase();
        switch (expression.operator) {
            case ComparisonOperator.Equal:
                return lowerCaseValue === lowerCaseExpressionValue;
            case ComparisonOperator.NotEqual:
                return lowerCaseValue != lowerCaseExpressionValue;
            case ComparisonOperator.Contains:
                return lowerCaseValue && lowerCaseValue.includes(lowerCaseExpressionValue);
            case ComparisonOperator.NotContains:
                return !lowerCaseValue || !lowerCaseValue.includes(lowerCaseExpressionValue);
        }

        return super.evaluate(expression, value);
    }
}

export class TextBox extends Field {
    placeholder: string;

    toJson() {
        const definition = super.toJson();
        assign(definition, {
            placeholder: this.placeholder,
        });
        return definition;
    }
}

export class TextBoxComparatorPickerBuilder extends ComparatorPickerBuilder {
    build(comparisonExpression: ComparisonExpression): ComparatorPicker {
        if (
            comparisonExpression.operator === ComparisonOperator.NotEmpty ||
            comparisonExpression.operator === ComparisonOperator.Empty
        ) {
            return new ComparatorPicker(ComparatorPickerType.None);
        }

        return new ComparatorPicker(ComparatorPickerType.Text);
    }
}
